// extracted by mini-css-extract-plugin
export default {"popup_container":"DetailsContainer_popup_container__TzaX0","popup_header":"DetailsContainer_popup_header__yDL57","popup_body":"DetailsContainer_popup_body__BANNi"};